import React from 'react';

import { ConsentPrompt } from 'src/components/ConsentPrompt';
import { PreflightError, usePreflight } from 'src/components/PreflightProvider';
import { PromptLayout } from 'src/components/PromptLayout';
import { useUser } from 'src/components/UserProvider/UserProvider';
import { useUserActions } from 'src/hooks/useUserActions';

const ConsentPagePrompt = () => {
  const {
    preflight: { hirerName, partnerName, scope, shouldShowShareableProfile },
  } = usePreflight();

  const user = useUser();

  const { apiError, onAccept, onReject, loading } = useUserActions();

  if (apiError) {
    return <PreflightError error={apiError} />;
  }

  return (
    <PromptLayout>
      <ConsentPrompt
        loading={loading}
        hirerName={hirerName}
        partnerName={partnerName}
        scope={scope}
        shouldShowShareableProfile={shouldShowShareableProfile}
        userEmail={user.email}
        onAccept={onAccept}
        onReject={onReject}
      />
    </PromptLayout>
  );
};

export const ConsentPage = () => <ConsentPagePrompt />;
